import React, { useEffect, useContext, useState } from 'react';
import { useIntl, FormattedMessage } from 'react-intl';
import { useLocation, useNavigate, Outlet } from 'react-router-dom';

import Typography from '@mui/material/Typography';
import Toolbar from '@mui/material/Toolbar';

import TabContainer from 'containers/TabContainer/TabContainer';
import ContextStore from 'modules/context';
import { useModuleMapping } from 'hooks/modules';

function SettingStaff() {
  const { formatMessage } = useIntl()
  const navigate = useNavigate()
  const { setBreadcrumbs } = useContext(ContextStore)
  const moduleMapping = useModuleMapping()
  const location = useLocation()
  const pathname = location.pathname
  const [activeTabIndex, setActiveTabIndex] = useState(undefined)

  let defaultSelect
  if (pathname === '/setting/staff/departments') {
    defaultSelect = 0
  } else if (pathname === '/setting/staff/occupation') {
    defaultSelect = 1
  } else if (pathname === '/setting/staff/appointmentType') {
    defaultSelect = 2
  }

  useEffect(() => {
    setBreadcrumbs([{
      text: formatMessage({ id: 'sideMenu.setting.root' })
    }])
  }, [pathname]);

  useEffect(() => {
    if (pathname === '/setting/staff/departments' && activeTabIndex !== 0) {
      setActiveTabIndex(0)
    } else if (pathname === '/setting/staff/occupation' && activeTabIndex !== 1) {
      setActiveTabIndex(1)
    } else if (pathname === '/setting/staff/appointmentType' && activeTabIndex !== 1) {
      setActiveTabIndex(2)
    }

    return () => {
    };
  }, [pathname]);

  const onTabSelected = (tabIndex) => {
    if (tabIndex === 0) {
      navigate('/setting/staff/departments');
    } else if (tabIndex === 1) {
      navigate('/setting/staff/occupation');
    } else if (tabIndex === 2) {
      navigate('/setting/staff/appointmentType');
    }
  }

  const tabs = [
    {
      label: formatMessage({ id: 'setStaff.departments.title' }),
      component: <Outlet />
    },
    {
      label: formatMessage({ id: 'setStaff.occupation.title' }),
      component: <Outlet />
    },
  ]
  if (moduleMapping.doctor && moduleMapping.appointment){
    tabs.push({
      label: formatMessage({ id: 'setStaff.appointmentType.table.title' }),
      component: <Outlet />
    })
  }

  return (
    <div style={{ padding: '12px 24px 80px 24px' }}>
      <Toolbar sx={{ pl: 2, pr: 1 }}>
        <Typography sx={{ flex: '1 1 100%', flexShrink: 2 }} variant="h6" id="tableTitle" component="div">
          <FormattedMessage id="setStaff.title" />
        </Typography>
      </Toolbar>
      <TabContainer activeTabIndex={activeTabIndex} defaultSelect={defaultSelect} tabs={tabs} onTabSelected={onTabSelected} />
    </div>
  );
}

export default SettingStaff;
